<template>
	<div v-if="!isLoading" class="item-list" :class="[{'data-accentcolor': accentColor}, '']" data-Favorite>
		<template v-for="(favorite, index) in profileFavorites" :key="'favorite'+index">
			<a class="item dropzone" @dragenter="dragFavoriteEnter($event, favorite.profileFavorite)" @dragover="dragFavoriteOver($event, favorite.profileFavorite)" @dragleave="dragFavoriteLeave($event, favorite.profileFavorite)" @drop="dropOnFavorite($event, favorite.profileFavorite, 'Up')"></a>
			<template v-if="favorite.profileFavorite.itemType=='Project'">
				<a :href="favorite.project.linkUrl" class="item" data-type="project" :key="favorite.project.idMaster" draggable="false">
					<div @dragstart="dragFavoriteStart($event, favorite.profileFavorite)" draggable="true" class="drag"><img src="/areas/privatearea/images/drag.svg" class="image" width="50" height="15" alt="drag"></div>
					<div class="top">
						<div class="date"><span class="icon fastic-folder"></span> {{ localizer.get("PrivateArea.Common.Project") }}</div>
						<div v-if="roles.split(',').filter(x=> x=='DREArea_Admin' || x == 'DREArea_Sales') && favorite.project.orderCode" class="codes">
							<span class="code">Ord. {{ favorite.project.orderCode }}</span>
						</div>
						<app-addprofilefavorite :itemIdMaster="favorite.project.idMaster" item-type="Project" :isFavoritePage="true" @updateData="getData()"></app-addprofilefavorite>
					</div>
					<div class="title">
						<span class="lable">{{ favorite.project.title }}</span>
					</div>
					<div class="box-image">
						<img v-if="favorite.project.fileCode" loading="lazy" :src="favorite.project.linkImage" width="405" height="303" :alt="favorite.project.title" draggable="false" />
						<div v-else class="placeholder"><div class="content"><span class="icon fastic-image"></span></div></div>
					</div>
				</a>
			</template>
			<template v-if="favorite.profileFavorite.itemType=='Asset'">
				<a :href="favorite.asset.linkUrl" class="item" :key="favorite.asset.idMaster" draggable="false">
					<div @dragstart="dragFavoriteStart($event, favorite.profileFavorite)" class="drag"><img src="/areas/privatearea/images/drag.svg" class="image" width="50" height="15" alt="drag"></div>
					<div class="top">
						<div class="date">{{ favorite.asset.dateItem }}</div>
						<div class="codes">
							<template v-if="roles.split(',').filter(x=> x=='DREArea_Admin' || x == 'DREArea_Sales') && favorite.asset.projectCode">
								<span class="code">Ord. {{ favorite.asset.projectCode }}</span>
							</template>
							<span class="code">Cod. {{ favorite.asset.code }}</span>
						</div>
						<app-addprofilefavorite :itemIdMaster="favorite.asset.idMaster" item-type="Asset" :isFavoritePage="true" @updateData="getData()"></app-addprofilefavorite>
					</div>
					<div class="title">
						<span class="lable">{{ favorite.asset.title }}</span>
					</div>
					<div class="box-image">
						<div v-if="favorite.asset.isApproved" class="approved-item"><span class="icon fastic-check"></span>{{ localizer.get("PrivateArea.Common.AssetApproved") }}</div>
						<img v-if="favorite.asset.fileCode" :src="favorite.asset.linkImage" loading="lazy" width="405" height="303" :alt="favorite.asset.title" draggable="false" />
						<div v-else class="placeholder"><div class="content"><span class="icon fastic-image"></span></div></div>
					</div>
				</a>
			</template>
			<a v-if="index === profileFavorites.length-1" class="item dropzone" :key="index" @dragenter="dragFavoriteEnter($event, favorite.profileFavorite)" @dragover="dragFavoriteOver($event, favorite.profileFavorite)" @dragleave="dragFavoriteLeave($event, favorite.profileFavorite)" @drop="dropOnFavorite($event, favorite.profileFavorite, 'Down')"></a>
		</template>
		<div v-if="profileFavorites.length===0" class="no-item">{{ localizer.get("PrivateArea.Common.Asset_ProfileFavoriteList_NoFavorite") }}</div>
	</div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";

const props = defineProps<{
	accentColor: string;
	roles: string;
}>();

const store = useStore();
const localizer = Localizer;
const isLoading = ref(false);
const profileFavorites = ref<any[]>([]);
const validationErrors = ref<any[]>([]);
const routes = (window as any).App.routes;

onMounted(async () => {
	await getData();
});

async function getData() {
	isLoading.value = true;
	const result = (await Axios.post(routes.PrivateArea_GetProfileFavoriteListData)).data;
	profileFavorites.value = result.profileFavorites;
	isLoading.value = false;
}

function dragFavoriteStart(e: any, favorite: any) {
	e.dataTransfer.setData("text", JSON.stringify({ profileFavoriteId: favorite.id, profileFavoriteType: favorite.itemType }));
}

function dragFavoriteEnter(e: any, favorite: any) {
	e.target.className = "item dropzone active";
}

function dragFavoriteOver(e: any, favorite: any) {
	e.preventDefault();
}

function dragFavoriteLeave(e: any, favorite: any) {
	e.target.className = "item dropzone";
	e.preventDefault();
}

async function dropOnFavorite(e: any, favorite: any, mode: string) {
	let data = JSON.parse(e.dataTransfer.getData("text"));
	e.preventDefault();
	e.target.className = "item dropzone";

	try {
		await Axios.post(routes.PrivateArea_MoveProfileFavorite, { profileFavoriteId: data.profileFavoriteId, profileFavoriteType: data.profileFavoriteType, targetProfileFavoriteId: favorite.id, targetProfileFavoriteType: favorite.itemType, mode: mode });

	} catch (error) {
		if (error.response && error.response.status === 400) {
			validationErrors.value = FormHelper.getValidationErrors(error.response.data);
		}
		for (const validationError of validationErrors.value) {
			store.dispatch("accountAreaToastStore/onAddToast", { message: validationError.message, type: "Warning" });
		}
	}

	getData();
}
</script>